import script from "./OrderedStepLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderedStepLinks.vue?vue&type=script&setup=true&lang=js"

import "./OrderedStepLinks.vue?vue&type=style&index=0&id=4a4283af&lang=scss"

const __exports__ = script;

export default __exports__